import { MapPin, Navigation } from "lucide-react";
import { BUSINESS, MAP_EMBED_SRC, MAP_DIRECTIONS } from "../lib/site";

// Carte Google Maps intégrée + bouton Itinéraire
export const MapCard = ({ testId = "map-card", height = "h-72" }) => {
  return (
    <div data-testid={testId} className="flex flex-col gap-4">
      <div className={`${height} w-full overflow-hidden border border-crustborder bg-dough`}>
        <iframe
          title="Localisation d'Au Fournil de Pierre à Nantes"
          src={MAP_EMBED_SRC}
          className="w-full h-full grayscale-[0.15] contrast-[1.02]"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
      <div className="flex items-start gap-3">
        <MapPin size={18} className="text-crust mt-0.5 shrink-0" />
        <address className="not-italic text-sm text-charcoal leading-relaxed">
          {BUSINESS.addressStreet}
          <br />
          {BUSINESS.addressCity}
        </address>
      </div>
      <a
        href={MAP_DIRECTIONS}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testId}-directions`}
        className="inline-flex items-center justify-center gap-2 kicker bg-crust text-cream px-6 py-4 transition-transform duration-200 active:scale-95 hover:bg-crustdark"
      >
        <Navigation size={15} />
        Itinéraire
      </a>
    </div>
  );
};
